<template>
  <div class="goods">
    <div class="top-container">
      <div class="goods-sales">
        <div class="goods-sales-title-container">
          <div class="title">
            <span>各类商品销售趋势图</span>
            <div class="search">
              <el-date-picker
                class="white w150"
                v-model="search.month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月份"
                @change="changeMonth"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <div id="goodsSales" :style="{ width: '100%', height: '320px' }"></div>
      </div>
    </div>

    <div class="content">
      <div class="ranking">
        <div class="ranking-title-container">
          <div class="title">
            <span>商品前十销售排行榜</span>
            <div class="search">
              <el-select
                class="white selectDate"
                v-model="searchRanking.select"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in selectDateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-date-picker
                class="white w150"
                v-if="searchRanking.select === 1"
                v-model="searchRanking.date"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="changeRankDate"
              >
              </el-date-picker>
              <el-date-picker
                class="white w150"
                v-if="searchRanking.select === 2"
                v-model="searchRanking.month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月份"
                @change="changeRankMonth"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <div
          id="rankingCharts"
          :style="{ width: '100%', height: '320px' }"
        ></div>
      </div>

      <div class="pie">
        <div class="pie-title-container">
          <div class="title">
            <span></span>
            <div class="search">
              <el-select
                class="white selectDate"
                v-model="searchPie.select"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in selectDateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-date-picker
                class="white w150"
                v-if="searchPie.select === 1"
                v-model="searchPie.date"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                @change="changePieDate"
              >
              </el-date-picker>
              <el-date-picker
                class="white w150"
                v-if="searchPie.select === 2"
                v-model="searchPie.month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月份"
                @change="changePieMonth"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <div id="pieCharts" :style="{ width: '100%', height: '320px' }"></div>
      </div>
    </div>

    <div class="foot-container">
      <div class="sales-ranking">
        <div class="sales-ranking-title-container">
          <div class="title">商品销售排行榜</div>
        </div>
        <div class="sales-search">
          <el-form ref="form" :model="form">
            <el-form-item prop="goodsName">
              <el-input
                class="white"
                v-model="form.goodsName"
                clearable
                placeholder="请输入商品名称"
              ></el-input>
            </el-form-item>
            <el-form-item prop="date" class="date-container">
              <el-date-picker
                v-model="form.date"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <div class="btn">
              <el-tooltip
                class="item"
                effect="dark"
                content="最多只可选择90天时间"
                placement="top"
              >
                <img
                  class="question-mark"
                  src="../../../../assets/home/question-mark.png"
                />
              </el-tooltip>
              <el-button class="btn-blue" @click="searchFnc">筛选</el-button>
            </div>
          </el-form>
        </div>
        <div class="table" ref="table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            v-loading="loading"
            height="232px"
          >
            <el-table-column
              v-for="(item, index) in tableTitle"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.width"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
          <div class="table_pagination">
            <pagination-tpl
              @queryChange="updatePage"
              :pageSize="pageSize"
              :currentPage="page"
              :total="total"
            ></pagination-tpl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DBReport from "models/db/report.js";
import PaginationTpl from "base/PaginationTpl";
import { formatTimeToDate } from "common/js/util.js";
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      goodsSalesEcharts: null,
      goodsSalesPieEcharts: null,
      rankingEcharts: null,
      search: {
        month: this.monthDefault(),
      },
      searchPie: {
        select: 1,
        date: this.timeDefault(),
        month: "",
      },
      searchRanking: {
        select: 1,
        date: this.timeDefault(),
        month: "",
      },
      selectDateList: [
        { label: "日数据", value: 1 },
        { label: "月数据", value: 2 },
      ],
      loading: true,
      total: 0, // 数据总数量
      page: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        { prop: "goodsName", label: "商品名称", width: "" },
        { prop: "nums", label: "下单个数", width: "" },
        { prop: "amount", label: "销售金额", width: "" },
      ],
      form: {
        goodsName: "",
        date: "",
      },
      selectDate: "",
      //日期选择范围在90天内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 90 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      cateGoryColorList: [
        "#FF0000",
        "#01B831",
        "#1858EB",
        "#BA2DEF",
        "#EACB1E",
        "#FF8383",
        "#FF4747",
        "#3CD964",
        "#FF5400",
        "#3D74F2",
        "#FF7A31",
        "#D76CFF",
        "#F9D851",
        "#FFA270",
        "#89E2A0",
        "#9AB9FF",
        "#E8ACFF",
        "#FFE88B",
      ],
    };
  },

  created() {
    this.initList();
  },

  mounted() {
    this.initGoodsSales();
    this.initGoodsPieSales();
    this.initRanking();
    window.addEventListener("resize", () => {
      this.initResize();
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.initResize();
    });
  },

  methods: {
    initGoodsSales() {
      let month = this.search.month;
      DBReport.getMonthGoodsSales(month).then((res) => {
        if (res.success) {
          let dateArr = [];
          let legendArr = [];
          let cateGoryList = res.result;
          let map = {};
          let newArr = [];
          for (let i = 0; i < cateGoryList.length; i++) {
            let obj = cateGoryList[i];
            let date = obj.date.slice(-5);
            dateArr.push(date);
            if (obj.categoryQuantityList.length !== 0) {
              for (let j = 0; j < obj.categoryQuantityList.length; j++) {
                let categoryObj = obj.categoryQuantityList[j];
                if (!map[categoryObj.categoryName]) {
                  let cateGoryColorLength = this.cateGoryColorList.length;
                  let color =
                    j < cateGoryColorLength
                      ? this.cateGoryColorList[j]
                      : this.cateGoryColorList[j - cateGoryColorLength];
                  newArr.push({
                    type: "line",
                    color: color,
                    name: categoryObj.categoryName,
                    data: [categoryObj.saleCount],
                  });
                  legendArr.push({
                    name: categoryObj.categoryName,
                  });
                  map[categoryObj.categoryName] = categoryObj;
                } else {
                  for (let k = 0; k < newArr.length; k++) {
                    let kObj = newArr[k];
                    if (kObj.name == categoryObj.categoryName) {
                      kObj.data.push(categoryObj.saleCount);
                    }
                  }
                }
              }
            } else {
              newArr.push({
                type: "line",
                name: '',
                data: [],
              });
            }
          }
          this.initGoodsSalesEchart(dateArr, legendArr, newArr);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    initGoodsPieSales() {
      let type = this.searchPie.select;
      let data = {};
      data.dateType = type;
      if (type == 1) {
        let date = this.searchPie.date;
        data.date = date;
      } else {
        let month = this.searchPie.month;
        data.date = month;
      }
      DBReport.getGoodsProportion(data).then((res) => {
        if (res.success) {
          let legendArr = [];
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            let obj2 = {};
            obj.name = i.categoryName;
            obj2.name = i.categoryName;
            obj.value = i.saleCount;
            obj.ratio = i.ratio;
            arr.push(obj);
            legendArr.push(obj2);
          });
          this.initGoodsSalesPicEchart(legendArr, arr);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    initRanking() {
      let type = this.searchRanking.select;
      let data = {};
      data.type = type;
      if (type == 1) {
        let date = this.searchRanking.date;
        data.date = date;
      } else {
        let month = this.searchRanking.month;
        data.date = month;
      }
      DBReport.getTenTopGoodsSales(data).then((res) => {
        if (res.success) {
          let dateArr = [];
          let salesYArr = [];
          res.result.map((i) => {
            dateArr.push(i.goodsName);
            salesYArr.push(i.saleCount);
          });
          this.initRankingEchart(dateArr, salesYArr);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 各类商品销售趋势图 */
    initGoodsSalesEchart(dateArr, legendArr, goodsSalesYArr) {
      this.goodsSalesEcharts = this.$echarts.init(
        document.getElementById("goodsSales")
      );
      this.goodsSalesEcharts.setOption({
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
        },
        legend: {
          type: "scroll",
          bottom: 8,
          // left: 36,
          icon: "rect",
          itemWidth: 6,
          itemHeight: 6,
          data: legendArr,
        },
        grid: {
          top: "10%",
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: dateArr,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          name: "单位：个",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        series: goodsSalesYArr,
      });
    },

    /* 各类商品分类占比 */
    initGoodsSalesPicEchart(legendArr, goodsSalesYArr) {
      this.goodsSalesPieEcharts = this.$echarts.init(
        document.getElementById("pieCharts")
      );
      let cateGoryColorList = this.cateGoryColorList;
      this.goodsSalesPieEcharts.setOption({
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          top: 20,
          bottom: 20,
          icon: "rect",
          itemWidth: 12,
          itemHeight: 12,
          padding: [0, 0, 20, 0],
          data: legendArr,
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 2,
              color: function (params) {
                let newColor = [];
                goodsSalesYArr.forEach((item, index) => {
                  newColor.push(cateGoryColorList[index % 18]);
                });
                return newColor[params.dataIndex];
              },
            },
            label: {
              formatter: "{b}\n{d}%",
            },
            data: goodsSalesYArr,
          },
        ],
      });
    },

    /* 商品前十销售排行榜 */
    initRankingEchart(dateArr, salesYArr) {
      this.rankingEcharts = this.$echarts.init(
        document.getElementById("rankingCharts")
      );
      this.rankingEcharts.setOption({
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          formatter: "销售区：" + "{b0}" + "<br/>" + "销售数量：" + "{c0}",
        },
        grid: {
          top: "10%",
          left: "4%",
          right: "2%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: dateArr,
          axisLabel: {
            interval: 0,
            // rotate: -30,
            formatter: function (params) {
              let newParamsName = ""; // 最终拼接成的字符串
              let paramsNameNumber = params.length; // 实际标签的个数
              let provideNumber = 4; // 每行能显示的字的个数
              // let rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              let rowNumber = 3; // 换行的话，需要显示几行，向上取整
              /**
              * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
              */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (let p = 0; p < rowNumber; p++) {
                  let tempStr = ""; // 表示每一次截取的字符串
                  let start = p * provideNumber; // 开始截取的位置
                  let end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    // tempStr = params.substring(start, paramsNameNumber);
                    if (paramsNameNumber > (provideNumber*rowNumber)) {
                      tempStr = params.substring(start, end) + "...";
                    } else {
                      tempStr = params.substring(start, end);
                    }
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          name: "单位：个",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          axisLabel: {
            formatter: (value) => {
              let texts = [];
              if (value == 0) {
                texts.push(value);
              } else {
                let num = value / 1000;
                let str = num + "k";
                texts.push(str);
              }
              return texts;
            },
          },
        },
        series: [
          {
            // 左侧柱形
            type: "bar",
            name: "area",
            data: salesYArr,
            barGap: 0,
            barMaxWidth: "auto",
            barWidth: 10,
            itemStyle: {
              color: "#92B3FF",
            },
          },
          {
            // 右侧柱形
            type: "bar",
            name: "area",
            data: salesYArr,
            barMaxWidth: "auto",
            barWidth: 10,
            itemStyle: {
              color: "#749EFF",
            },
          },
          {
            // 顶部菱形
            data: salesYArr,
            type: "pictorialBar",
            barMaxWidth: "20",
            symbolPosition: "end",
            symbol: "diamond",
            symbolOffset: [0, "-50%"],
            symbolSize: [20, 10],
            zlevel: 3,
            itemStyle: {
              color: "#ABC4FF",
            },
          },
        ],
      });
    },

    initResize() {
      this.goodsSalesEcharts.resize();
      this.goodsSalesPieEcharts.resize();
      this.rankingEcharts.resize();
    },

    initList() {
      let goodsName = this.form.goodsName;
      let beginDate = this.form.date.length > 0 ? this.form.date[0] : "";
      let endDate = this.form.date.length > 0 ? this.form.date[1] : "";
      let pageNo = this.page;
      let data = {
        goodsName,
        beginDate,
        endDate,
        pageNo,
      };
      DBReport.getGoodsSalesRankingList(data).then((res) => {
        if (res.success) {
          this.total = res.result.totalNum;
          this.pageSize = res.result.pageSize;
          let arr = [];
          res.result.items.map((i) => {
            let obj = {};
            obj.goodsName = i.goodsName;
            obj.nums = i.saleCount;
            obj.amount = i.saleAmount;
            arr.push(obj);
          });
          this.tableData = arr;
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.message);
        }
      });
    },

    timeDefault() {
      let date = new Date();
      let s1 = formatTimeToDate(date.getTime() - 86400000);
      return s1;
    },

    monthDefault() {
      let date = new Date();
      let month = date.getMonth() + 1;
      month = month > 9 ? month : "0" + month;
      let s1 = date.getFullYear() + "-" + month;
      return s1;
    },

    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.initList();
    },

    searchFnc() {
      this.page = 1;
      this.initList();
    },

    changeMonth(v) {
      this.initGoodsSales();
    },

    changePieDate() {
      this.initGoodsPieSales();
    },

    changePieMonth() {
      this.initGoodsPieSales();
    },

    changeRankDate() {
      this.initRanking();
    },

    changeRankMonth() {
      this.initRanking();
    },
  },
};
</script>

<style lang='scss'>
.goods {
  flex: 1;
  padding: 0px 16px 16px;
  overflow-y: auto;
  box-sizing: border-box;
  .top-container {
    display: flex;
    justify-content: flex-start;
    background: white;
    .goods-sales {
      width: 100%;
      padding: 0px 19px;
      border-radius: 4px;
      box-sizing: border-box;
      &-title-container {
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 18px;
          font-weight: 500;
          color: #666666;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .search {
            padding-top: 12px;
            .w150 {
              width: 160px;
            }
            .selectDate {
              width: 85px;
              .el-input__inner {
                border-right-width: 0.5px;
                border-radius: 4px 0px 0px 4px;
              }
            }
            .el-date-editor {
              .el-select.white .el-input__inner,
              .el-input__inner {
                border-left-width: 0.5px;
                border-radius: 0px 4px 4px 0px;
              }
            }
          }
        }
      }
    }
  }
  .content {
    display: flex;
    justify-content: flex-start;
    margin-top: 16px;
    background: white;
    .ranking,
    .pie {
      width: 50%;
      padding: 0px 19px;
      border-radius: 4px;
      box-sizing: border-box;
      background: white;
      &-title-container {
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 18px;
          font-weight: 500;
          color: #666666;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .search {
            padding-top: 12px;
            .w150 {
              width: 160px;
            }
            .selectDate {
              width: 85px;
              .el-input__inner {
                border-right-width: 0.5px;
                border-radius: 4px 0px 0px 4px;
              }
            }
            .el-date-editor {
              .el-select.white .el-input__inner,
              .el-input__inner {
                border-left-width: 0.5px;
                border-radius: 0px 4px 4px 0px;
              }
            }
          }
        }
      }
    }
  }
  .foot-container {
    display: flex;
    justify-content: flex-start;
    margin-top: 16px;
    .sales-ranking {
      width: 100%;
      padding: 0px 19px;
      border-radius: 4px;
      box-sizing: border-box;
      background: white;
      &-title-container {
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 18px;
          font-weight: 500;
          color: #666666;
        }
      }
      .sales-search {
        height: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .el-form {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          .el-form-item {
            margin-bottom: 0px;
          }
          .date-container {
            margin-left: 16px;
          }
          .btn {
            .question-mark {
              width: 14px;
              height: 14px;
              margin-left: 8px;
              margin-right: 21px;
            }
          }
        }
      }
      .table {
        .table_pagination {
          height: 56px;
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .el-pagination {
            height: 28px;
            padding: 0px;
            display: flex;
          }
        }
        .el-table__body {
          width: 100% !important;
        }
        .el-table--scrollable-y .el-table__body-wrapper {
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 4px;
            box-shadow: inset 0 0 5px #d3d3d3;
            background: #dcdcdc;
          }
        }
      }
    }
  }
}
</style>
